import { useMutation, useQuery } from '@apollo/client';
import { track } from '@bnnvara/analytics/src/track';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { BOOKMARK } from '../../graphql/mutations/bookmark.graphql';
import { IS_BOOKMARKED } from '../../graphql/queries/isBookmarked.graphql';
import { getBookmarkIcon } from './BookmarkIcon';
import { handleClick } from './handleClick';
import * as S from './styled';

const Bookmark = ({ userId, mediaId }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(undefined);
  const [toggleBookmark] = useMutation(BOOKMARK);

  /**
   * Only execute this query if we are logged in.
   */
  const { data, error } = useQuery(IS_BOOKMARKED, {
    fetchPolicy: 'network-only',
    variables: {
      userId,
      contentId: String(mediaId),
      contentType: 'media',
    },
    skip: !userId,
  });

  /**
   * Responsible for setting the states after the query has been executed.
   * If an error is returned, we decide to set the default state to false.
   */
  useEffect(() => {
    if (data?.me) {
      setIsBookmarked(data?.me?.isBookmarked);
    }
    if (error) {
      setIsBookmarked(false);
    }
  }, [data, error]);

  /**
   * This useEffect is responsible for not showing the tooltip
   * after X amount of time.
   */
  useEffect(() => {
    let timeOut;

    if (showTooltip === true) {
      timeOut = setTimeout(() => {
        setShowTooltip(false);
        clearTimeout(timeOut);
      }, 10000);
    }
    return () => {
      clearTimeout(timeOut);
    };
  }, [showTooltip, setShowTooltip]);

  /**
   * To prevent that somebody is able to click
   * before the initial isBookmarked state is being retrieved.
   */
  if (isBookmarked === undefined) return null;

  return (
    <>
      <S.BookmarkButton
        label="bookmark video"
        onClick={() =>
          handleClick({
            isBookmarked,
            toggleBookmark,
            mediaId,
            setIsBookmarked,
            setShowTooltip,
            userId,
          })
        }
      >
        {getBookmarkIcon(isBookmarked)}
      </S.BookmarkButton>
      {showTooltip && (
        <S.BookmarkTooltip>
          {isBookmarked ? 'Toegevoegd aan ' : 'Verwijderd uit '}
          <a
            href="https://www.bnnvara.nl/profiel"
            rel="noopener noreferrer"
            target="_blank"
            onClick={() => {
              track('video-player-bookmark', 'click', 'bnnvara profile');
            }}
          >
            bewaarde video&apos;s
          </a>
        </S.BookmarkTooltip>
      )}
    </>
  );
};

Bookmark.propTypes = {
  userId: PropTypes.string,
  mediaId: PropTypes.string.isRequired,
};

export default Bookmark;
